import * as STD                 from '@emersya/mpa-std';
import * as CM                  from '@emersya/mpa-components-manager';

export class TextualRenderingMode extends CM.Plugin<
	InputNumberComponent
> {
	id = 'textual';

	private async onInput({target}: Event) {
		if (!target) {
			return;
		}
		const input = <HTMLInputElement>target;
		const container = <HTMLDivElement>input.parentElement?.parentElement;
		const component = <InputNumberComponent>(<Record<any, any>>container.details).component;
		const cleanStr = input.value.split('').filter(x => x === '.' || x === ',' || (x >= '0' && x <= '9')).join('');
		const cleanValue = Number.parseFloat(cleanStr);
		const errorTextNode = <HTMLElement>component.component_querySelector('.pluginTextual .error');
		if (!errorTextNode) {
			component.component_throwLibraryError('', {});
		}
		errorTextNode.textContent = '';
		if (component.isValidValue(cleanValue)) {
			if (cleanStr !== input.value) {
				await component.updateValue(cleanStr ? cleanValue : 0);
			} else {
				if (component.value !== cleanValue) {
					await component.updateValue(cleanValue);
				}
			}
		} else {
			const langId = (<any>window).app.currentLanguage;
			const unit = <string | undefined>component.component_configuration?.['@translations']?.unit?.[langId]?.toLowerCase();
			(<HTMLInputElement>component.component_DOM.querySelector('input')).value = (<number>component.value).toString() + (unit ? ' ' + unit : '');
			if (!cleanStr) {
				return;
			}
			let label = '';
			if (component.component_configuration['@translations']?.label?.[langId]) {
				label = component.component_configuration['@translations']?.label?.[langId];
			} else if (
				component.component_parent &&
				(component.component_parent instanceof FieldNS.Component) &&
				component.component_parent.component_configuration['@translations']?.label?.[langId]
			) {
				label = component.component_parent.component_configuration['@translations']?.label?.[langId];
			}
			if (!label) {
				component.component_throwUserError('Input does not have label!', {});
			}
			if (component.min > cleanValue) {
				errorTextNode.textContent =
					langId === 'fr' ?
						`Impossible : La ${label} minimale est de ${component.min}!` :
						`Impossible : The minimum ${label} is ${component.min}!`;
			} else if (component.max < cleanValue) {
				errorTextNode.textContent =
					langId === 'fr' ?
						`Impossible : La ${label} maximale est de ${component.max}!` :
						`Impossible : The maximum ${label} is ${component.max}!`;
			}

			await component.updateValue(cleanValue);

			setTimeout(() => {
				errorTextNode.textContent = '';
			}, 2500);
		}

	};

	private onUpdated(ev: STD.events.Event<InputNumberComponent, CM.Component<any, any>>) {
		const component = ev.target;
		const value = <number>ev.details.newValue;
		const langId = (<any>window).app.currentLanguage;
		const unit = <string | undefined>component.component_configuration?.['@translations']?.unit?.[langId]?.toLowerCase();
		(<HTMLInputElement>component.component_DOM.querySelector('input')).value = value.toString() + (unit ? ' ' + unit : '');
	};

	attach(component: InputNumberComponent) {
		component.component_DOM.dataset.renderingMode = this.id;
		component.component_DOM.appendChild(STD.DOM.factory({
			classList: ['pluginTextual'],
			childs: [
				{
					tag: 'input',
					attributes: {
						type: 'text'
					},
					events: {
						input: STD.misc.createDebouncer({
							fn: <() => void><any>this.onInput.bind(this),
							delay: 1000
						})
					}
				},
				{
					classList: ['error']
				}
			]
		}));
		component.addEventListener('value', this.onUpdated, {
			listener: component,
			subType: component.static.type
		});
	};

	detach(component: InputNumberComponent) {
		void component;
	};

	async boundsUpdated(component: InputNumberComponent, stepsCountDiff: number) {
		void component;
		void stepsCountDiff;
		await <Promise<void>><any>void 1;
	};

	constructor() {
		super();
		this.onInput = this.onInput.bind(this);
		this.onUpdated = this.onUpdated.bind(this);
	};
};
import { InputNumberComponent } from '../InputNumber';
import './Textual.scss';
import { NS as FieldNS }        from '../../../Field/Field';
